import React, { useState } from 'react';
import portfolioData from '../../data/portfolioData.js';

const Portfolio = () => {
  const [filter, setFilter] = useState('all');

  const filteredPortfolio = filter === 'all' 
    ? portfolioData 
    : portfolioData.filter(item => item.category === filter);

  return (
    <section id="portfolio" className="portfolio">
      <div className="container">
        <h2 className="section-title">Our Portfolio</h2>
        <div className="portfolio-filters">
          <button 
            className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All
          </button>
          <button 
            className={`filter-btn ${filter === 'wedding' ? 'active' : ''}`}
            onClick={() => setFilter('wedding')}
          >
            Wedding
          </button>
          <button 
            className={`filter-btn ${filter === 'pre-wedding' ? 'active' : ''}`}
            onClick={() => setFilter('pre-wedding')}
          >
            Pre-Wedding
          </button>
          <button 
            className={`filter-btn ${filter === 'engagement' ? 'active' : ''}`}
            onClick={() => setFilter('engagement')}
          >
            Engagement
          </button>
          <button 
            className={`filter-btn ${filter === 'haldi' ? 'active' : ''}`}
            onClick={() => setFilter('haldi')}
          >
            Haldi
          </button>
          <button 
            className={`filter-btn ${filter === 'mehendi' ? 'active' : ''}`}
            onClick={() => setFilter('mehendi')}
          >
            Mehendi
          </button>
          <button 
            className={`filter-btn ${filter === 'reception' ? 'active' : ''}`}
            onClick={() => setFilter('reception')}
          >
            Reception
          </button>
        </div>
        <div className="portfolio-grid">
          {filteredPortfolio.map((item) => (
            <div key={item.id} className="portfolio-item">
              <img src={item.image} alt={item.title} />
              <div className="portfolio-overlay">
                <h3>{item.title}</h3>
                <p>{item.category}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
